import React from 'react'
import { Loader, Dimmer } from 'semantic-ui-react'

const CustomLoader = () => (<Dimmer active style={{ 'z-index': '9999' }}>
    <Loader size='massive'>Loading</Loader>
</Dimmer>)
export default CustomLoader
